import { useModal } from 'bootstrap-vue-next'
import { useVueNextModalStore } from '@/store/vueNextModal'

const modals: any[] = []

export const registerModals = (name: string) => {
  const existingModalIndex = modals.findIndex((modal: any) => modal.name === name)
  if (existingModalIndex !== -1) {
    modals.splice(existingModalIndex, 1) // Remove existing modal
  }

  const { show, hide, current } = useModal()
  modals.push({ name, show, hide, modal: current()?.modal })
}

export const openModal = (modalName: string, data = {}) => {
  useVueNextModalStore().openModal({ name: modalName, data })
}
